import { useDispatch } from "react-redux";

import { setSelectedShapefile } from "store/features";

import { ShapefileFileType } from "models/projects";

import { Icon_Draggable } from "components/icons";

import { useUser } from "../../../../../../../../../hooks";
import {
  FlexItem,
  LayerActionsWrapper,
  LeafTitle,
  ProjectLinkedShapefileActions,
  ProjectLinkedShapefileColorPicker
} from "../../../../shared";
import { useRightClickContextMenu } from "../../../../shared/hooks/useRightClickContextMenu";

interface IOrganizationShapefileNode {
  node;
  canSelectItems?: boolean;
}

export function OrganizationShapefileNode({
  node,
  canSelectItems
}: IOrganizationShapefileNode) {
  const dispatch = useDispatch();
  const { hasTrialAccount, isReadonly } = useUser();
  const { openContextMenu, contextMenuObject, nodeRef } = useRightClickContextMenu();

  return (
    <LeafTitle
      ref={nodeRef}
      onContextMenu={openContextMenu}
      data-testid="shapefile-node-container">
      <div className="drag-container">
        <Icon_Draggable />
      </div>
      <FlexItem>
        <ProjectLinkedShapefileColorPicker
          projectShapefileId={node.projectShapefileId}
          shapefileId={node.shapefileId}
          color={node.layer.style.color}
          strokeColor={node.layer.style.strokeColor}
          thickness={node.layer.style.thickness}
          opacity={node.layer.style.opacity}
          fileType={node.fileType}
          lineStyle={
            node.fileType !== ShapefileFileType.GeoTiff
              ? node.layer.style.lineStyle ?? "solid"
              : undefined
          }
          fillPattern={
            node.fileType !== ShapefileFileType.GeoTiff
              ? node.layer.style.fillPattern ?? "none"
              : undefined
          }
        />
        <label data-testid="shapefile-title">{node.title}</label>
      </FlexItem>
      <FlexItem>
        <LayerActionsWrapper>
          <ProjectLinkedShapefileActions
            canExportShapefile={!hasTrialAccount && !isReadonly}
            projectShapefileId={node.projectShapefileId}
            viewShapefileDetails={() => dispatch(setSelectedShapefile(node))}
            contextMenu={contextMenuObject}
            fileName={node.title}
            hasSelectItemsAction={canSelectItems}
          />
        </LayerActionsWrapper>
      </FlexItem>
    </LeafTitle>
  );
}
